import Vue                  from "vue";
import { mapGetters }       from "vuex";
import { LoadingSpinner,
    DnFunctionButton, DnRouterLink }      from "@/components/Elements"
import moment               from "moment";

export default Vue.extend({
    name: "LanterShippingDetail",
    components: {
        LoadingSpinner,
        DnFunctionButton,
        DnRouterLink
    },
    props: {
        lanterShippingDetails: {
            type: Array,
        }, 
        invoiceNumber: {
            type: String,
        },
        invoiceId: {
            type: Number
        }
    },
    computed: {
        ...mapGetters(["getContentItem"]),
        groupedLanterScans(){
            var grouped = new Object;
            this.shippingContainers.forEach(shippingNumber => {
                grouped[shippingNumber] = this.lanterShippingDetails.filter(x => x.ShippingNumber === shippingNumber).sort(y => y.ScannedTime);
            });
            return grouped;
        },
        shippingContainers(){
            return new Set(this.lanterShippingDetails.map(x => x.ShippingNumber));
        },
    },
    methods: {
        formatNewsStoryDate: function (value: string | Date) {
            return moment(value).format("MMM D, YYYY");
        },
        returnToInvoices(){
            this.$emit("return");
        },
        getLocalDateString(dateString){
            //Create UTC date string - don't use toUTCString() because it will assume the string is in local time
            var utcDateString = new Date(dateString).toLocaleString() + " GMT";
            //Automatically converts from UTC to local time
            var date = new Date(utcDateString);
            var dateOptions = window.Intl.DateTimeFormat().resolvedOptions();
            return date.toLocaleString(dateOptions.locale, {timeZoneName: 'short' });
        },
        getLastStatus(shippingNumber){
            var scans = this.groupedLanterScans[shippingNumber];
            return scans[scans.length - 1];
        },
        isDelivered(shippingContainer){
            return this.getLastStatus(shippingContainer).ScanType === 'Delivery'
        }
    }
})